import styled from 'styled-components';
import {CustomIcon} from '@guestapp/old-ui-kit';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const Wrapper = styled.div`
  position: absolute;
  top: -24px;
  left: 0;
  width: 100%;
  padding: 24px 0;
  background: rgba(56, 91, 248, 0.1);

  @media (min-width: ${DEVICE.laptop}) {
    position: initial;
    background: transparent;
    padding: 0;
    margin-bottom: 24px;
  }
`;

export const Container = styled.div`
  max-width: 327px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;

  @media (min-width: ${DEVICE.laptop}) {
    max-width: 100%;
    margin: 0;
    padding: 8px 0 16px;
    border-bottom: 1.5px solid #dbdde1;
  }
`;

export const GuestInformation = styled.div`
  display: flex;
  gap: 8px;
  cursor: pointer;
  color: ${({theme}) => theme.colors.buttons.textButton};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.15px;
`;

export const StyledIcon = styled(CustomIcon)`
  margin-top: 7px;
`;

export const Lowercase = styled.span`
  text-transform: lowercase;
`;
